module.exports = __webpack_public_path__ + "img/15.8340dc36.jpg";